import { SyncManager, type TripField } from '../lib/sync-manager';

/**
 * Slice-side sync helpers.
 *
 * Every store mutation that should be persisted to the server goes through
 * this module instead of reaching into `SyncManager.getInstance()` directly.
 * Two reasons:
 *
 *  1. Tests can mock the bridge without monkey-patching the SyncManager
 *     singleton.
 *  2. Future shape changes (different transport, different mark semantics,
 *     conflict-aware enqueue) only touch this file — the eight slices stay
 *     coupled to a stable, narrow API.
 */

export function markTripDirty(tripId: string, fields: TripField[]): void {
  SyncManager.getInstance().markDirty(tripId, fields);
}

export function markTripNew(tripId: string): void {
  SyncManager.getInstance().markNew(tripId);
}

export function markTripDeleted(tripId: string): void {
  SyncManager.getInstance().markDeleted(tripId);
}
